import { render, staticRenderFns } from "./imgLoad.vue?vue&type=template&id=639fbfd0"
import script from "./imgLoad.vue?vue&type=script&lang=js"
export * from "./imgLoad.vue?vue&type=script&lang=js"
import style0 from "./imgLoad.vue?vue&type=style&index=0&id=639fbfd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports